import React, { useEffect, useState } from "react";
import AdminDashboard from "./admindashboard";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router";
import AddDocument from "./addDocuments";
import { FaEdit, FaTrash } from "react-icons/fa";
import "./hm-theme.css";

function Documentation() {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const token = JSON.parse(localStorage.getItem("data")).token;
  const navigate = useNavigate();

  const getData = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`/api/documentation`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setDocuments(response.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      handleError(error);
    }
  };

  const handleError = (error) => {
    if (error.response && error.response.status === 401) {
      navigate("/signin");
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(
        error.response?.data?.message || error.response?.data?.code || "An error occurred."
      );
    }
  };

  const handleAddDocuments = () => {
    setSelectedId(null);
    setIsModalOpen(true);
  };

  const handleEdit = (id) => {
    setSelectedId(id);
    setIsModalOpen(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this document?")) {
      setLoading(true);
      try {
        await axios.delete(`/api/documentation`, {
          headers: { Authorization: `Bearer ${token}` },
          data: { id },
        });
        toast.success("Document deleted successfully");
        getData();
      } catch (error) {
        handleError(error);
      } finally {
        setLoading(false);
      }
    }
  };

  const handleAddCloseModal = () => {
    setIsModalOpen(false);
    getData();
  };

  const handleView = (fileMeta, fileContent, fileName) => {
    const linkSource = `data:${fileMeta};base64,${fileContent}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName || "document.pdf";
    downloadLink.click();
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <AdminDashboard />
      <div className="col-10 mx-xl-auto ps-xl-10 mt-10 pe-xl-4">
        <div className="hm-page-wrapper">
          {/* Header */}
          <div className="hm-page-header mb-4">
            <div>
              <h2 className="hm-page-title">
                <i className="material-icons">description</i>
                Document Settings
              </h2>
              <p className="hm-page-subtitle">
                Manage platform documentation files and document templates.
              </p>
            </div>
          </div>

          {/* Main Card */}
          <div className="hm-card">
            <div className="hm-card-header d-flex align-items-center justify-content-between">
              <h3 className="hm-card-title mb-0">
                <i className="material-icons">folder_shared</i>
                Uploaded Documents
              </h3>
              <button className="btn-hm-primary" onClick={handleAddDocuments}>
                <i className="material-icons" style={{ fontSize: "1rem" }}>
                  add
                </i>
                Add Document
              </button>
            </div>
            <div className="hm-card-body p-0">
              {loading && <div className="loading"></div>}
              <div style={{ overflowX: "auto" }}>
                <table className="hm-table">
                  <thead>
                    <tr>
                      <th>Document Name</th>
                      <th>File</th>
                      <th className="text-end pe-4">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {documents.length === 0 ? (
                      <tr>
                        <td colSpan="3">
                          <div className="hm-empty-state py-4">
                            <i className="material-icons">description</i>
                            <p>{loading ? "Loading documents..." : "No documents available"}</p>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      documents.map((doc) => (
                        <tr key={doc.id}>
                          <td className="fw-semibold">{doc.fileName}</td>
                          <td>
                            <button
                              className="btn btn-outline-primary btn-sm rounded-pill py-0 px-2 d-inline-flex align-items-center gap-1"
                              style={{ fontSize: "0.75rem" }}
                              onClick={() => handleView(doc.fileMeta, doc.file, doc.fileName)}
                            >
                              <i className="material-icons" style={{ fontSize: "0.85rem" }}>
                                visibility
                              </i>
                              View File
                            </button>
                          </td>
                          <td className="text-end pe-4">
                            <div className="d-inline-flex align-items-center gap-2">
                              <button
                                className="btn btn-sm btn-outline-warning p-1 border-0 rounded-circle d-flex align-items-center justify-content-center"
                                title="Edit Document"
                                onClick={() => handleEdit(doc.id)}
                              >
                                <FaEdit />
                              </button>
                              <button
                                className="btn btn-sm btn-outline-danger p-1 border-0 rounded-circle d-flex align-items-center justify-content-center"
                                title="Delete Document"
                                onClick={() => handleDelete(doc.id)}
                              >
                                <FaTrash />
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isModalOpen && (
        <AddDocument isOpen={isModalOpen} onRequestClose={handleAddCloseModal} id={selectedId} />
      )}
    </div>
  );
}

export default Documentation;

